import { t } from 'i18next';
import { DEFAULT_CURRENCY } from '../../../constants/currency';
import { formatMoneyRounded } from '../../../utils/format-money';

/**
 * Format a plan's price for display. `null` is used to represent a plan with
 * no fixed price (e.g. enterprise), and is rendered as a localised "Custom"
 * label.
 */
export function formatPlanPrice(price: number | null): string {
  if (price === null) {
    return t('features:billing.components.plan_card.price.custom');
  }

  return formatMoneyRounded(price, DEFAULT_CURRENCY);
}
